import { useList } from '../../../../../../../api/react-query';

export const useEmpPortalMenuSuggestion = () => {
  const { data, isLoading, refetch } = useList(
    'config/empportalMenu/config/suggestions',
    {},
    { enabled: true },
    'v2',
  );

  return {
    data: data?.data?.data || [],
    isLoading,
    suggetionCount: data?.data?.count || 0,
    refetch,
  };
};
